export default __webpack_public_path__ + "static/media/step3.303315a4.webm";